import { createContext } from "react"
import { HEADER_MAX_LINES } from "../constants"

export const HeaderMaxLinesContext = createContext<number>(HEADER_MAX_LINES)
